import { isServer } from './util';

export function getSearchString() {
    if (!isServer) {
        return location.search;
    } else {
        return '';
    }
}

export function getSearchParams() {
    const queryString = getSearchString();
    const searchParams = new URLSearchParams(queryString);
    return searchParams;
}
